import { v4 as uuidv4 } from 'uuid';

/**
 * Ottiene o genera un identificativo univoco per il dispositivo corrente.
 * Il valore viene salvato in localStorage per essere riutilizzato nei login successivi.
 */
export function getDeviceId(): string {
  let id = localStorage.getItem('device_id');
  if (!id) {
    id = uuidv4();
    localStorage.setItem('device_id', id);
  }
  return id;
}
